/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Professional/view.blocks to change it.
import Professionals from './Professionals/index'
import React from 'react'
import Term from './Term/index'



/** @type {import('Simple/types.js').View} */
export default function Professional({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/New/Confirm/Content/Referral/Value/Search/Professional"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Professional.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Term
  viewPath={`${viewPath}/Term`}
/>
<Professionals
  viewPath={`${viewPath}/Professionals`}
/>
</div>
{children}
</React.Fragment>)
}